import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./common/styles/fonts.css";
import { BrowserRouter } from "react-router-dom";
import theme from "./common/styles/theme.ts";
import { ThemeProvider } from "@mui/material/styles";
import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
  <ThemeProvider theme={theme}>
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>
  </ThemeProvider>
);
